import React, { useState, useEffect, useMemo } from 'react';
import cn from 'classnames';
import { Container, Markup, Button } from '@landing/ui';
import { observer, cookies as cookiesStore, modal as modalStore } from 'store';
import { CONSENT_COOKIE_NAME, CONSENT_MODAL_ID, getCookieOptions } from 'define/cookies';
import { setCookie, getCookie } from 'utils/cookie';
import { pushCookiePolicyEvent } from 'utils';

import data from './data.json';

import * as styles from './CookiesPolicy.module.scss';

function CookiesPolicy() {
  const [fullDescription, setFullDescription] = useState(false);
  const [consent, setConsent] = useState({ ad_storage: true, analytics_storage: true });

  const acceptCookies = () => {
    setCookie(CONSENT_COOKIE_NAME, JSON.stringify(consent), getCookieOptions());
    pushCookiePolicyEvent();
  };

  const onAccept = () => {
    acceptCookies();
    cookiesStore.setSeen(true);
  };

  const onManage = () => {
    modalStore.open(CONSENT_MODAL_ID);
    cookiesStore.setSeen(true);
  };

  useEffect(() => {
    const consentStatus = JSON.parse(getCookie(CONSENT_COOKIE_NAME));
    if (consentStatus) {
      setConsent(prev => ({ ...prev, ...consentStatus }));
    }
  }, []);

  useEffect(() => {
    if (!getCookie(CONSENT_COOKIE_NAME)) {
      cookiesStore.setSeen(false);
    }
  }, []);

  const finalDescription = useMemo(() => {
    if (!fullDescription) {
      return data?.description.slice(0, data?.description.indexOf('\r'));
    }

    return data?.description;
  }, [data?.description, fullDescription]);

  return (
    <div className={cn(styles.wrapper, cookiesStore.seen && styles.hidden)}>
      <Container padding="Without" background="transparent">
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <div>
              <Markup tag="span" className={styles.text}>
                {finalDescription}
              </Markup>
              <button
                onClick={() => setFullDescription(!fullDescription)}
                className={cn(styles.showMore, fullDescription && styles.active)}
              >
                {!fullDescription ? data?.showMore : data?.hide}
              </button>
            </div>
          </div>
          {data?.manage && (
            <button className={styles.manageButton} onClick={onManage}>
              {data?.manage}
            </button>
          )}
          <Button
            className={cn(styles.button, !data?.manage && styles.withMargin)}
            onClick={onAccept}
            fullWidthMobile
          >
            {data?.accept}
          </Button>
        </div>
      </Container>
    </div>
  );
}

export default observer(CookiesPolicy);
